import { Navigate, useParams } from "react-router";
import { useDevice } from "./device";

/** `/t/:taskId` deep links (spec §10) open the panel beside the device dashboard. */
export function TaskRedirect() {
  const { taskId } = useParams();
  const device = useDevice((s) => s.dashboard);
  return <Navigate to={`${device ? `/d/${device}` : "/list"}?task=${taskId}`} replace />;
}
